import http from "../http/http-config";
import { CUPECheckout } from "../models/cupeCheckout";

export default new class CUPEService {

    GetCUPEUrl(
        productId,
        email,
        GUId?): Promise<CUPECheckout> {
        const safeGuId = GUId ?? "";

        const params = {
            productId,
            email,
            GUId: safeGuId
        };

        return http
            .get<CUPECheckout>("CUPE", { params })
            .then(response => response.data);
    };

    Finish(externalIdentifier, productId, apellido: string | null | undefined, dni: string | null | undefined, localidad: string | null | undefined, mail: string | null | undefined, nombre: string | null | undefined, nroCotizacion: string | null | undefined, premioMensual: number | null | undefined, productoComercial: string | null | undefined, ramo: string | null | undefined, telephoneArea: string | null | undefined, telephoneNumber: string | null | undefined): Promise<boolean> {
        return http.get<boolean>("CUPE/Finish", {
            params: {
                externalIdentifier
                , productId
                , ...(apellido != null && { apellido })
                , ...(dni != null && { dni })
                , ...(localidad != null && { localidad })
                , ...(mail != null && { mail })
                , ...(nombre != null && { nombre })
                , ...(nroCotizacion != null && { nroCotizacion })
                , ...(premioMensual != null && { premioMensual })
                , ...(productoComercial != null  && { productoComercial })
                , ...(ramo != null && { ramo })
                , ...(telephoneArea != null && { telephoneArea })
                , ...(telephoneNumber != null && { telephoneNumber })
    }
}).then(response => response.data)
    };
}